<template>
  <div class="customer-upload">
    <el-upload
      ref="refCustomerUpload"
      action
      :http-request="uploadHttpRequest"
      :show-file-list="false"
      :multiple="multiple"
      :file-list="fileList"
      :before-remove="beforeUploadRemove"
      :before-upload="handleBeforeUpload"
      :on-change="handleOnChange"
      :on-remove="handleOnRemove"
      :on-success="handleOnSuccess"
      :on-error="handleOnError"
      v-bind="$attrs"
      v-on="$listeners"
      :disabled="!editable"
    >
      <slot>
        <!-- <p>{{imgInfo.img.url}}</p> -->
        <img v-if="imgInfo.img && imgInfo.img.url" :src="imgInfo.img && imgInfo.img.url" class="avatar">
        <div class="avatar-uploader-icon" v-else>
          <div class="cycle"><i class="el-icon-camera-solid icon"></i></div>
        </div>
        <!-- <i class="el-icon-camera-solid avatar-uploader-icon"></i> -->
        <!-- <el-button
          :disabled="!editable"
          size="medium"
          type="primary"
        >{{ $t(`${i18n}clickUploadFile`) }}</el-button> -->
        <!-- <div
          slot="tip"
          class="el-upload__tip"
        >{{ desc }}</div> -->
      </slot>
    </el-upload>
  </div>
</template>

<script>
// import oss from 'ali-oss'
import axios from 'axios'
import { formatDate } from '@/utils/index'
import { documentGetUploadPolicy, documentAdd } from '@/api/upload'

const i18n = 'upload.'

let CancelToken
let cancel

export default {
  name: 'CustomerUpload',
  props: {
    // action: {
    //   type: String,
    //   required: true,
    // },
    editable: {
      type: Boolean,
      default: true,
    },
    multiple: {
      type: Boolean,
      default: true,
    },
    fileList: {
      type: Array,
    },
    imgInfo: {
      type: Object,
    },
    desc: {
      type: String,
      default () {
        return this.$t(`${i18n}uploadDefaultDesc`)
      },
    },
    uploadDir: {
      type: String,
      required: true,
    },
    userId: {
      type: Number,
      default: 0,
    },
    fileType: {
      type: Array,
    },
    fileSize: {
      type: Number,
      default: 10,
    },
  },
  data () {
    const aliOssConfig = {
      accessKeyId: 'LTAICVMTztXxOYM9',
      accessKeySecret: 'tTxJ10TXUpg05uWZRTRtMLiccZJ3iB',
      baseCheckFailedDir: 'check_failed',
      baseCheckFailedHost: 'http://resources.ostay.cc',
      baseReferenceDir: 'reference',
      baseRoadGuideDir: 'house_check_in_guide',
      payEvidenceBaseDir: 'pay/evidence',
      payEvidenceHost: 'http://resources.ostay.cc',
      referenceHost: 'http://resources.ostay.cc',
      roadGuideHost: 'http://resources.ostay.cc',
      endpoint: 'oss-ap-northeast-1.aliyuncs.com',
      bucket: 'ostay-open-img',
      domain: 'resources.ostay.cc',
    }
    return {
      i18n,
      config: {
        ossDomain: '', // 'resources.ostay.cc',
        uploadFolder: '', // 'supplierContract/file'
      },
      aliOssConfig,
      // ossClient: oss(aliOssConfig),
    }
  },
  methods: {
    // 获取文件命名
    filePathGen (localFileName) {
      if (localFileName.indexOf('.') < 0) {
        return null
      }
      localFileName = `${this.userId}_${new Date().getTime()}_${localFileName}`
      const dir = `${this.uploadDir || this.config.uploadFolder}/${formatDate(new Date(), 'yyyy-MM-dd')}`
      return {
        dir,
        path: `${dir}/${localFileName}`, // `${dir}/${new Date().getTime()}${suffix}`,
      }
    },
    // upload-重写上传请求（通过oss）
    uploadHttpRequest (option) {
      const that = this
      const prom = new Promise(() => {
        const pathGen = this.filePathGen(option.file.name)
        try {
        // 1. 先获取证书
          documentGetUploadPolicy({
            bucketId: 2,
            dir: pathGen.dir,
          }).then(policyRes => {
            if (policyRes.errCode === '200') {
              const {
                OSSAccessKeyId,
                policy,
                signature,
                host,
                // expire
              } = policyRes.data

              // 2. 上传到ali cloud
              const params = new FormData()
              params.append('OSSAccessKeyId', OSSAccessKeyId)
              params.append('policy', policy)
              params.append('signature', signature)
              params.append('key', pathGen.path)
              params.append('file', option.file)
              params.append('success_action_status', 200)
              axios.post(host, params, {
                headers: { 'Content-Type': 'multipart/form-data' },
                onUploadProgress (progressEvent) {
                  const percentCompleted = Math.floor((progressEvent.loaded * 100) / progressEvent.total)
                  that.$emit('change-percent', percentCompleted)
                  option.onProgress({ percent: percentCompleted })
                },
                cancelToken: new CancelToken(function executor (c) {
                  // An executor function receives a cancel function as a parameter
                  cancel = c
                }),
              }).then(postRes => {
                if (postRes.status === 200) {
                // 3. 添加文件进数据库，返回data为文件编号
                  documentAdd({
                    bucketId: 2,
                    fileKey: pathGen.path,
                  }).then(addRes => {
                    if (addRes.errCode === '200') {
                      this.$emit('getFileKey', { fileKey: pathGen.path, id: addRes.data })
                      this.$set(option.file, 'id', addRes.data)
                      option.onSuccess(this.$t(`${i18n}uploadSuccess`))
                    } else {
                      // option.onError('添加文件失败')
                      option.onError(this.$t(`${i18n}uploadFail`))
                    }
                  })
                } else {
                  option.onError(this.$t(`${i18n}uploadFail`))
                }
              }).catch(err => {
                this.$emit('error', err)
              })
            } else {
              // option.onError('获取证书失败')
              option.onError(this.$t(`${i18n}uploadFail`))
            }
          })
        } catch (error) {
          option.onError(error.errMsg || this.$t(`${i18n}uploadFail`))
        }
      })
      prom.abort = () => {}
      return prom
    },
    handleBeforeUpload (file) {
      // 校验文件类型
      if (this.fileType && this.fileType.length > 0 && this.fileType.indexOf(file.name.substring(file.name.lastIndexOf('.') + 1)) === -1) {
        this.$message.error(`${this.$t(`${i18n}uploadFormatWarning`)}: ${this.fileType.join()}`)
        return false
      }
      // 校验尺寸
      if (this.fileSize && this.fileSize > 0 && file.size / 1024 / 1024 > this.fileSize) {
        this.$message.error(`${this.$t(`${i18n}uploadSizeWarning`)}: ${this.fileSize}M`)
        return false
      }
      // 组件自带校验不能上传重复文件名
      const list = this.fileList
      if (list.length > 0) {
        let repeatFlag = false
        for (const item of list) {
          if (item.name === file.name) {
            repeatFlag = true
            break
          }
        }
        if (repeatFlag) {
          this.$message.error(this.$t(`${this.i18n}duplicateWarning`))
          return false
        } else {
          return true
        }
      } else {
        return true
      }
    },
    handleOnChange (file, fileList) {
      // console.log('handleOnChange:', file, fileList)
      this.$emit('update:file-list', fileList)
      if (this.checkUploadFile(fileList)) {
        this.$emit('success', this.getDocIds(fileList))
      }
    },
    handleOnRemove (file, fileList) {
      // console.log(file, fileList)
      this.$emit('update:file-list', fileList)
      if (this.checkUploadFile(fileList)) {
        this.$emit('success', this.getDocIds(fileList))
      }
    },
    handleOnSuccess (res) {
      if (res) {
        this.$message.success(res)
      }
    },
    handleOnError (err) {
      if (err) {
        this.$message.error(err)
        this.$emit('error', err)
      }
    },
    // upload-移除前的钩子
    beforeUploadRemove (file) {
      if (file.status === 'uploading') {
        cancel(this.$t(`${this.i18n}cancelUpload`))
        this.$message.success(this.$t(`${this.i18n}cancelUpload`))
      }
    },
    // 取消上传
    abort (file) {
      this.$refs.refCustomerUpload.abort(file)
    },
    // 检查上传的文件是否准确
    checkUploadFile (fileList) {
      const list = fileList || []
      if (list.length > 0) {
        let errorFlag = false
        for (const item of list) {
          if (item.status !== 'success') {
            errorFlag = true
            break
          }
          const id = (item.raw && item.raw.id) || item.id // item.raw || {}
          if (id !== 0 && !id) {
            errorFlag = true
            break
          }
        }
        if (errorFlag) {
          // this.$message.error('正在上传中')
          return false
        }
      } else {
        // this.$message.error('请上传文件')
        // return false
        return true
      }
      return true
    },
    getDocIds (fileList) {
      const ids = []
      fileList.forEach(item => {
        const id = (item.raw && item.raw.id) || item.id
        if (id) {
          ids.push(id)
        }
      })
      return ids.join()
    },
  },
  watch: {

  },
  created () {
    // 默认加载文件时，仍然调用success，保证docIds的准确
    if (this.fileList.length > 0) {
      this.$emit('success', this.getDocIds(this.fileList))
    }
  },
  mounted () {
    CancelToken = axios.CancelToken
  },
}
</script>

<style lang="scss" scoped>
.customer-upload {
  /deep/ .el-upload--picture-card {
    width: 120px;
    height: 120px;
    line-height: 120px;
  }
  /deep/ .el-upload-list--picture-card .el-upload-list__item {
    width: 120px;
    height: 120px;
    // line-height: 120px;
  }
  .el-upload__tip {
    white-space: pre-wrap;
    font-size: 14px;
  }
}

/deep/ .el-upload {
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
    background-color: #E0E2E5;
    position: relative;
  }
  .customer-upload .el-upload:hover {
    border-color: #409EFF;
  }
  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 178px;
    height: 98px;
    line-height: 98px;
    text-align: center;
  }
  .avatar {
    width: 178px;
    height: 98px;
    display: block;
    object-fit: contain;
  }

  .cycle {
    width: 36px;
    height: 36px;
    border-radius: 50%;
    background-color: #fff;
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%,-50%);
    .icon {
      position: absolute;
      left: 8px;
      font-size: 20px;
      text-align: center;
      line-height: 36px;
    }
  }
</style>
